<!--
 * @,@Author: ,: your name
 * @,@Date: ,: 2020-11-12 17:14:10
 * @,@LastEditTime: ,: 2021-01-27 09:45:50
 * @,@LastEditors: ,: Please set LastEditors
 * @,@Description: ,: In User Settings Edit
 * @,@FilePath: ,: \mall-admin-web\src\views\layout\components\Sidebar\SidebarItem.vue
 -->
<!--<template>-->
<!--  <div class="menu-wrapper">-->
<!--    <template v-for="item in routes" >-->
<!--      <template v-if="!item.hidden&&item.children">-->
<!--      <router-link-->
<!--        v-if="hasOneShowingChildren(item.children) && !item.children[0].children&&!item.alwaysShow"-->
<!--        :to="item.path+'/'+item.children[0].path"-->
<!--        :key="item.children[0].name">-->
<!--        <el-menu-item :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}">-->
<!--          <svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon"-->
<!--                    :icon-class="item.children[0].meta.icon"></svg-icon>-->
<!--          <span v-if="item.children[0].meta&&item.children[0].meta.title"-->
<!--                slot="title">{{item.children[0].meta.title}}</span>-->
<!--        </el-menu-item>-->
<!--      </router-link>-->

<!--      <el-submenu-->
<!--        v-else :index="item.name||item.path"-->
<!--        :key="item.name">-->
<!--        <template slot="title">-->
<!--          <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>-->
<!--          <span v-if="item.meta&&item.meta.title" slot="title">{{item.meta.title}}</span>-->
<!--        </template>-->

<!--        <template v-for="child in item.children" >-->
<!--          <template v-if="!child.hidden">-->
<!--            <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0"-->
<!--              :routes="[child]" :key="child.path"></sidebar-item>-->

<!--            <div v-else @click="pageTurn(item.path+'/'+child.path)" :key="child.name">-->
<!--              <el-menu-item :index="item.path+'/'+child.path">-->
<!--                <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>-->
<!--                <span v-if="child.meta&&child.meta.title" slot="title">{{child.meta.title}}</span>-->
<!--              </el-menu-item>-->
<!--            </div>-->
<!--          </template>-->
<!--        </template>-->
<!--      </el-submenu>-->
<!--      </template>-->
<!--    </template>-->
<!--  </div>-->
<!--</template>-->

<!--<script>-->
<!--  export default {-->
<!--    name: 'SidebarItem',-->
<!--    props: {-->
<!--      routes: {-->
<!--        type: Array-->
<!--      },-->
<!--      isNest: {-->
<!--        type: Boolean,-->
<!--        default: false-->
<!--      }-->
<!--    },-->
<!--    methods: {-->
<!--      pageTurn(path){-->
<!--        if (this.$route.path === path) {-->
<!--          this.$router.go(0);-->
<!--        } else {-->
<!--          this.$router.push(path)-->
<!--        }-->
<!--        //-->
<!--      },-->
<!--      hasOneShowingChildren(children) {-->
<!--        const showingChildren = children.filter(item => {-->
<!--          return !item.hidden-->
<!--        })-->
<!--        if (showingChildren.length === 1) {-->
<!--          return true-->
<!--        }-->
<!--        return false-->
<!--      }-->
<!--    },-->
<!--    created() {-->
<!--      // console.log("routes:",this.routes)-->
<!--    }-->

<!--  }-->
<!--</script>-->


<template>
  <div v-if="!item.hidden" class="menu-wrapper">
    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <item :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)" :title="onlyOneChild.meta.title" :badge="getShowNum(onlyOneChild.name)"/>
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
  import path from 'path'
  import { isExternal } from '@/utils/validate'
  import Item from './Item'
  import AppLink from './Link'
  import FixiOSBug from './FixiOSBug'
  export default {
    name: 'SidebarItem',
    components: { Item, AppLink },
    mixins: [FixiOSBug],
    props: {
      // route object
      item: {
        type: Object,
        required: true
      },
      isNest: {
        type: Boolean,
        default: false
      },
      basePath: {
        type: String,
        default: ''
      }
    },
    data() {
      // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
      // TODO: refactor with render function
      this.onlyOneChild = null
      return {}
    },
    methods: {
      hasOneShowingChild(children = [], parent) {
        const showingChildren = children.filter(item => {
          if (item.hidden) {
            return false
          } else {
            // Temp set(will be used if only has one showing child)
            this.onlyOneChild = item
            return true
          }
        })
        // When there is only one child router, the child router is displayed by default
        if (showingChildren.length === 1) {
          return true
        }
        // Show parent if there are no child router to display
        if (showingChildren.length === 0) {
          this.onlyOneChild = { ... parent, path: '', noShowingChildren: true }
          return true
        }
        return false
      },
      resolvePath(routePath) {
        if (isExternal(routePath)) {
          return routePath
        }
        if (isExternal(this.basePath)) {
          return this.basePath
        }
        return path.resolve(this.basePath, routePath)
      },
      getShowNum(menuName) {
        if (menuName === 'afterSaleOrderList' || menuName === 'saleAfterSaleOrderList') {
          if (this.$store.getters.countData && this.$store.getters.countData.afterSaleNum) {
            return this.$store.getters.countData.afterSaleNum
          }
        }
        if (menuName === 'requirement') {
          if (this.$store.getters.countData && this.$store.getters.countData.requireNum) {
            return this.$store.getters.countData.requireNum
          }
        }
        return null
      }
    }
  }
</script>
<style scoped>
 .menu-wrapper /deep/  .el-menu-item:hover,.menu-wrapper /deep/ .el-menu-item:focus{
   background-color: #001528 !important;
  }
 .menu-wrapper /deep/ .el-submenu__title:hover{
   background-color: #001528 !important;
 }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue